import { toast } from "react-toastify";
import historicalSearchStore from "@/store/historicalSearchStore";

// Shared by the right-click item and the header chip's X so both end the view the same way.
export function returnToLiveTrades(cryptoID: string) {
  historicalSearchStore.getState().endHistoricalSearch(cryptoID);
  toast("Historical trade view ended");
}

type SearchByCryptoId = ReturnType<
  typeof historicalSearchStore.getState
>["searchByCryptoId"];

// LQC-3142 - the blotter rebuilds historical rows from the search results on every live update,
// so allocations must live on the results or the next rebuild drops them.
export function returnSearchesWithAllocations(
  searchByCryptoId: SearchByCryptoId,
  esid: string,
  allocations: any[],
): SearchByCryptoId {
  let changed = false;
  const next: SearchByCryptoId = {};
  Object.entries(searchByCryptoId).forEach(([cryptoID, search]) => {
    if (!search.historicTradeDataForDataRange.some((trade) => trade.esid == esid)) {
      next[cryptoID] = search;
      return;
    }
    changed = true;
    next[cryptoID] = {
      ...search,
      historicTradeDataForDataRange: search.historicTradeDataForDataRange.map(
        (trade) => (trade.esid == esid ? { ...trade, allocations } : trade),
      ),
    };
  });
  return changed ? next : searchByCryptoId;
}

export function addAllocationsToHistoricalSearches(esid: string, allocations: any[]) {
  const { searchByCryptoId } = historicalSearchStore.getState();
  const next = returnSearchesWithAllocations(searchByCryptoId, esid, allocations);
  if (next != searchByCryptoId) historicalSearchStore.setState({ searchByCryptoId: next });
}
